import { forwardRef, Injectable, Inject } from "@angular/core";

@Injectable()
export class Utils {
  title: string;
  show: string;
  showBusy: boolean;
  ERROR_MSG: any;

  firstName: string;
  lastName: string;

  places: any[];
  selectedPlace: string;

  piwikSiteIds: any[];
  ANALYTICS: any;

  ALERT: any = {};
  errorsList: any[] = [];

  ERROR_CODE: any;

  placeID: string;
  companyCustID: string;
  stagingPlaceID: string;

  app: string;
  path: string;

  backButtonCTA = "";
  continueButtonCTA = "";

  constructor() {
    this.title = "PLACE";
    this.show = "place";
    this.showBusy = false;

    this.ERROR_MSG = {
      SELECT_PLACE_ERROR_MSG:
        "NO SELECTION MADE: Please select one place from the list or choose to add a place not on the list.",
    };

    this.ERROR_CODE = {
      ADDRESS_NOT_FOUND_TEXT: "ADDRESS NOT FOUND",
      ADDRESS_NOT_FOUND_CODE: "address-not-found",
      USPS_RANGE_ERROR_CODE: "Range Error",
      USPS_MULTIPLE_MATCHES_CODE: "Multiple Matches",
      USPS_PERFECT_MATCH_CODE: "No Error",
      NO_LAT_LONG_CODE: "no-lat-long",
      INVALID_COORDINATES: "INVALID COORDINATES",
      INVALID_COORDINATES_CODE: "invalid-lat-long",
      NOT_IN_AZ_ERR_MSG: "not-in-az",
      IN_INDIAN_COUNTRY_TEXT: "INDIAN COUNTRY RESTRICTIONS",
      IN_INDIAN_COUNTRY_CODE: "in-indian-country",
    };

    this.ALERT["NOT_IN_AZ_ERR_MSG"] = {
      title: "LOCATION NOT IN ARIZONA",
      msg: "The place you requested is not in Arizona. Please call ADEQ at (844) 827-4768 if you need further assistance.",
      mainButtonText: "OK",
      mainButtonCTA: null,
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["IN_INDIAN_COUNTRY_ERR_MSG"] = {
      title: "INDIAN COUNTRY RESTRICTIONS",
      msg: "You have indicated you will be operating in Indian Country. ADEQ does not have jurisdiction in Indian Country. Please contact the local tribal environmental agency or the EPA if the local agency does not exist.",
      mainButtonText: "RETURN TO mySTUFF",
      mainButtonCTA: "/mydeq/dashboard",
      leftButtonText: null,
      leftButtonCTA: null,
    };

    this.ALERT["DUPLICATE_PLACE_NAME_ERR_MSG"] = {
      title: "ALERT",
      msg: "The exact place name you chose already exists in your list of places. Please rename this new place with additional information such as adding a store number, etc. See example below. <br /> <br /> <strong>Example: ABC Store change to ABC Store #865</strong>",
      mainButtonText: "OK",
      mainButtonCTA: null,
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["DUPLICATE_PLACE_ADDRESS_ERR_MSG"] = {
      title: "PLACE ALREADY EXISTS",
      msg: "The address or latitude/longitude you entered already exists for in your list of places. Please choose this existing place by clicking on the Go TO myPLACES LIST button.",
      mainButtonText: "GO TO myPLACES LIST",
      mainButtonCTA: "place",
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["NO_LATLONG_ERR_MSG"] = {
      title: "ADDRESS NOT FOUND",
      msg: "We are unable to convert your address to latitude and longitude. Please enter your latitude and longitude coordinates.",
      mainButtonText: "OK",
      mainButtonCTA: null,
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["similar-addressed-picked"] = {
      title: "ALERT",
      msg: "We found a similar address location in our database that we will be using to attach this permit to. Please note that this new location will appear on your dashboard for this permit.",
      mainButtonText: "OK",
      mainButtonCTA: this.continueButtonCTA,
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["PORTABALE_PLACE_SELECTED"] = {
      title: "ALERT: SELECTED AIR PERMIT PLACE",
      msg: "Selected address or latitude/longitude not allowed for this permit. In order to continue you must choose different place from myPLACES or click 'Return to myStuff' to exit.",
      mainButtonText: "OK",
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.ALERT["PERMIT_ALREADY_EXIST"] = {
      title: "ALERT",
      msg: "You already have a similar Permit for this location. You can amend your permit by selecting AMEND PERMIT button, that will return you to mySTUFF.",
      mainButtonText: "AMEND PERMIT",
      mainButtonCTA: "/mydeq/dashboard",
      leftButtonText: "RETURN TO mySTUFF",
      leftButtonCTA: "/mydeq/dashboard",
    };

    this.piwikSiteIds = [
      { hostName: "localhost", siteId: 1 },
      { hostName: "mydev.azdeq.gov", siteId: 1 },
      { hostName: "myqa.azdeq.gov", siteId: 3 },
      { hostName: "myuat.azdeq.gov", siteId: 5 },
      { hostName: "mybeta.azdeq.gov", siteId: 4 },
      { hostName: "my.azdeq.gov", siteId: 6 },
    ];

    this.ANALYTICS = {
      CATEGORY: "FLEET",
      SELECT_COMPANY: "Select your Company",
      IS_NEW_PERMIT: "Is this New Permit",
    };

    this.ANALYTICS.REGISTER = {
      CATEGORY: "REGISTRATION_EQUIPMENT",
      SELECT_COMPANY: "Select your Company",
      IS_NEW_PERMIT: "Is this New Permit",
      CERTIFIED_TECHNICIAN: "Do you have Certified Technician",
    };
  }

  public getPiwikSiteId = (hostname) => {
    for (let i = 0; i < this.piwikSiteIds.length; i++) {
      const piwikSite = this.piwikSiteIds[i];
      if (piwikSite.hostName === hostname) {
        return piwikSite.siteId;
      }
    }
    return 1;
  };

  public getRedirectURI = () => {
    return (
      this.continueButtonCTA +
      "?place_id=" +
      this.placeID +
      "&stage_id=" +
      this.stagingPlaceID +
      "&cust_id=" +
      this.companyCustID
    );
  };

  public redirectToParentApp = () => {
    const url: string = this.getRedirectURI();
    window.open(url, "_self");
  };
}
